@if (!editing) {
  <div class="meta-chip">
    <app-account-icon class="meta-icon" [name]="icon" [size]="13"></app-account-icon>
    <span class="meta-key">{{ label }}</span>
    @if (value) {
      <span class="meta-value">{{ value }}</span>
    }
    <button type="button" class="meta-pen" [attr.aria-label]="editLabel" (click)="startEdit()">
      <app-account-icon name="pen" [size]="12"></app-account-icon>
    </button>
  </div>
} @else {
  <form class="meta-edit" (ngSubmit)="save()">
    <input
      #editInput
      name="inlineEditValue"
      [type]="inputType"
      [attr.inputmode]="inputType"
      [attr.maxlength]="maxLength"
      [attr.aria-label]="label"
      [placeholder]="placeholder || label"
      [value]="draft"
      [disabled]="saving"
      (input)="onDraftInput($event)"
      (keydown)="onKeydown($event)"
    />
    <button type="submit" class="meta-action meta-save" [attr.aria-label]="saveLabel" [disabled]="saving">
      <app-account-icon name="check" [size]="12" [strokeWidth]="3"></app-account-icon>
    </button>
    <button
      type="button"
      class="meta-action meta-cancel"
      [attr.aria-label]="'Cancel' | translate"
      [disabled]="saving"
      (click)="cancel()"
    >
      <app-account-icon name="x" [size]="12" [strokeWidth]="2.5"></app-account-icon>
    </button>
  </form>
}
